export const modalStack = {
  get stack() {
    const stack = sessionStorage.getItem("modalStack");
    return stack ? JSON.parse(stack) : [];
  },

  set stack(value) {
    sessionStorage.setItem("modalStack", JSON.stringify(value));
  },

  push(modalId) {
    const stack = this.stack;
    stack.push(modalId);
    this.stack = stack;
  },

  pop() {
    const stack = this.stack;
    const modalId = stack.pop();
    this.stack = stack;
    const previousModal = stack.length > 0 ? stack[stack.length - 1] : null;
    return previousModal;
  },

  get modalAtivo() {
    return this.stack.length > 0 ? this.stack[this.stack.length - 1] : null;
  },
};

export default modalStack;
